var _defs, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _g, _g2, _g3, _g4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPlayStore(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 135.716,
    height: 40.019,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    x1: 31.8,
    y1: 183.29,
    x2: 15.017,
    y2: 166.508,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(.8 0 0 -.8 0 161.6)",
    id: "i"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#00a0ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.007,
    stopColor: "#00a1ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.26,
    stopColor: "#00beff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.512,
    stopColor: "#00d2ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#00dfff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00e3ff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: 43.834,
    y1: 171.999,
    x2: 19.638,
    y2: 171.999,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(.8 0 0 -.8 0 161.6)",
    id: "j"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ffe000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.409,
    stopColor: "#ffbd00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.775,
    stopColor: "orange"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ff9c00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: 34.827,
    y1: 169.704,
    x2: 12.069,
    y2: 146.946,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(.8 0 0 -.8 0 161.6)",
    id: "k"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ff3a44"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#c31162"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: 17.297,
    y1: 191.824,
    x2: 27.46,
    y2: 181.661,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(.8 0 0 -.8 0 161.6)",
    id: "l"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#32a071"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.069,
    stopColor: "#2da771"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.476,
    stopColor: "#15cf74"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.801,
    stopColor: "#06e775"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00f076"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h124v48H0V0z"
  })), /*#__PURE__*/React.createElement("mask", {
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 1,
    height: 1,
    id: "m"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h124v48H0V0z",
    fillOpacity: 0.2
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "n"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h124v48H0V0z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "b"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h124v48H0V0z"
  })), /*#__PURE__*/React.createElement("pattern", {
    patternTransform: "matrix(1 0 0 -1 0 48)",
    patternUnits: "userSpaceOnUse",
    width: 124,
    height: 48,
    id: "o"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#b)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M29.625 20.695l-11.613-6.597c-.649-.371-1.231-.344-1.606-.008l-.058-.063.058-.058c.375-.336.957-.36 1.606.011l11.687 6.641-.074.074z"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "c"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h124v48H0V0z"
  })), /*#__PURE__*/React.createElement("mask", {
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 1,
    height: 1,
    id: "p"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#c)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h124v48H0V0z",
    fillOpacity: 0.12
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "q"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h124v48H0V0z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "d"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h124v48H0V0z"
  })), /*#__PURE__*/React.createElement("pattern", {
    patternTransform: "matrix(1 0 0 -1 0 48)",
    patternUnits: "userSpaceOnUse",
    width: 124,
    height: 48,
    id: "r"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#d)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.348 14.145c-.235.246-.371.628-.371 1.125v-.118c0-.496.136-.879.371-1.125l.058.063-.058.055z"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "e"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h124v48H0V0z"
  })), /*#__PURE__*/React.createElement("mask", {
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 1,
    height: 1,
    id: "s"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#e)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h124v48H0V0z",
    fillOpacity: 0.12
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "t"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h124v48H0V0z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "f"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h124v48H0V0z"
  })), /*#__PURE__*/React.createElement("pattern", {
    patternTransform: "matrix(1 0 0 -1 0 48)",
    patternUnits: "userSpaceOnUse",
    width: 124,
    height: 48,
    id: "u"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#f)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M33.613 22.961l-3.988-2.266.074-.074 3.914 2.223c.559.316.836.734.836 1.156-.047-.379-.332-.75-.836-1.039z"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "g"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h124v48H0V0z"
  })), /*#__PURE__*/React.createElement("mask", {
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 1,
    height: 1,
    id: "v"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#g)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h124v48H0V0z",
    fillOpacity: 0.25
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "w"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h124v48H0V0z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "h"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h124v48H0V0z"
  })), /*#__PURE__*/React.createElement("pattern", {
    patternTransform: "matrix(1 0 0 -1 0 48)",
    patternUnits: "userSpaceOnUse",
    width: 124,
    height: 48,
    id: "x"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#h)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18.012 33.902l15.601-8.863c.508-.289.789-.66.836-1.039 0 .418-.277.836-.836 1.156L18.012 34.02c-1.117.632-2.035.105-2.035-1.176v-.114c0 1.278.918 1.805 2.035 1.172z",
    fill: "#fff"
  }))))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M130.54 39.943H5.24c-2.755 0-5.012-2.23-5.012-4.954V5.267C.228 2.544 2.485.314 5.24.314h125.3c2.755 0 5.011 2.23 5.011 4.953V34.99c0 2.724-2.256 4.954-5.012 4.954z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M130.54 1.108c2.32 0 4.208 1.866 4.208 4.16v29.721c0 2.294-1.888 4.16-4.209 4.16H5.24c-2.32 0-4.208-1.866-4.208-4.16V5.267c0-2.293 1.888-4.16 4.208-4.16h125.3m0-.793H5.24C2.485.314.228 2.544.228 5.267V34.99c0 2.724 2.257 4.954 5.012 4.954h125.3c2.755 0 5.011-2.23 5.011-4.954V5.267c0-2.723-2.256-4.953-5.012-4.953z",
    fill: "#a6a6a6"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M45.934 16.195c0 .668-.2 1.203-.594 1.602-.453.473-1.043.711-1.766.711a2.426 2.426 0 0 1-1.765-.719c-.485-.484-.727-1.078-.727-1.789 0-.711.242-1.305.727-1.785a2.414 2.414 0 0 1 1.765-.723c.344 0 .672.071.985.203.312.133.566.313.75.535l-.418.422c-.321-.379-.758-.566-1.317-.566-.504 0-.941.176-1.312.531-.367.356-.551.817-.551 1.383 0 .566.184 1.031.551 1.387a1.85 1.85 0 0 0 1.312.531c.535 0 .985-.18 1.34-.535.234-.235.367-.559.402-.973h-1.742v-.578h2.324c.028.125.036.246.036.363zm3.687-2.004h-2.183v1.52h1.968v.578h-1.968v1.52h2.183v.589H46.82v-4.796h2.801v.589zm2.602 4.207h-.618v-4.207h-1.339v-.589h3.297v.589h-1.34v4.207zm3.726 0v-4.796h.617v4.796h-.617zm3.352 0h-.613v-4.207h-1.344v-.589h3.301v.589h-1.344v4.207zm7.586-.617c-.473.485-1.059.727-1.758.727-.703 0-1.289-.242-1.762-.727-.472-.484-.707-1.078-.707-1.781 0-.703.235-1.297.707-1.781.473-.485 1.059-.727 1.762-.727.695 0 1.281.242 1.754.731.476.488.711 1.078.711 1.777 0 .703-.235 1.297-.707 1.781zm-3.063-.402c.356.359.789.539 1.305.539.512 0 .949-.18 1.301-.539.355-.359.535-.82.535-1.379s-.18-1.02-.535-1.379a1.756 1.756 0 0 0-1.301-.539c-.516 0-.949.18-1.305.539-.355.359-.535.82-.535 1.379s.18 1.02.535 1.379zm4.637 1.019v-4.796h.75l2.332 3.73h.027l-.027-.922v-2.808h.617v4.796h-.644l-2.442-3.914h-.027l.027.926v2.988h-.613z",
    fill: "#fff",
    stroke: "#fff",
    strokeWidth: 0.16,
    strokeMiterlimit: 10,
    transform: "matrix(1.25299 0 0 1.23841 -9.796 -9.594)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M68.526 21.865c-2.354 0-4.277 1.77-4.277 4.214 0 2.424 1.923 4.213 4.277 4.213 2.36 0 4.283-1.79 4.283-4.213 0-2.443-1.923-4.214-4.283-4.214zm0 6.768c-1.291 0-2.403-1.054-2.403-2.554 0-1.52 1.112-2.555 2.403-2.555 1.292 0 2.409 1.035 2.409 2.555 0 1.5-1.117 2.554-2.409 2.554zm-9.333-6.768c-2.36 0-4.278 1.77-4.278 4.214 0 2.424 1.918 4.213 4.278 4.213 2.358 0 4.278-1.79 4.278-4.213 0-2.443-1.92-4.214-4.278-4.214zm0 6.768c-1.293 0-2.408-1.054-2.408-2.554 0-1.52 1.115-2.555 2.408-2.555 1.292 0 2.403 1.035 2.403 2.555 0 1.5-1.111 2.554-2.403 2.554zm-11.107-5.477v1.791h4.327c-.127 1-.465 1.736-.984 2.249-.631.62-1.615 1.307-3.343 1.307a4.722 4.722 0 0 1-4.747-4.756 4.722 4.722 0 0 1 4.747-4.756c1.44 0 2.488.557 3.26 1.277l1.277-1.262c-1.08-1.02-2.52-1.804-4.537-1.804-3.65 0-6.72 2.936-6.72 6.545s3.07 6.545 6.72 6.545c1.974 0 3.456-.639 4.621-1.838 1.194-1.18 1.567-2.84 1.567-4.18 0-.416-.035-.798-.098-1.118h-6.09zm45.416 1.389c-.352-.943-1.438-2.68-3.651-2.68-2.193 0-4.018 1.707-4.018 4.214 0 2.36 1.806 4.213 4.228 4.213a4.238 4.238 0 0 0 3.554-1.868l-1.453-.957c-.485.701-1.146 1.166-2.1 1.166-.949 0-1.63-.43-2.065-1.277l5.702-2.332-.197-.48zm-5.814 1.403c-.049-1.625 1.277-2.457 2.227-2.457.744 0 1.376.367 1.586.894l-3.813 1.563zm-4.634 4.088h1.874V17.652h-1.874v12.384zm-3.07-7.233h-.063c-.421-.493-1.224-.938-2.242-.938-2.135 0-4.087 1.852-4.087 4.228 0 2.361 1.952 4.199 4.087 4.199 1.018 0 1.821-.45 2.242-.957h.063v.604c0 1.611-.871 2.477-2.276 2.477-1.145 0-1.855-.817-2.149-1.505l-1.63.673c.47 1.117 1.714 2.491 3.78 2.491 2.197 0 4.051-1.278 4.051-4.387V22.12h-1.776v.682zm-2.144 5.83c-1.292 0-2.373-1.07-2.373-2.54 0-1.485 1.081-2.569 2.373-2.569 1.273 0 2.277 1.084 2.277 2.569 0 1.47-1.004 2.54-2.277 2.54zm24.438-10.981h-4.483v12.384h1.87v-4.693h2.613c2.076 0 4.112-1.485 4.112-3.846 0-2.36-2.04-3.845-4.112-3.845zm.049 5.969h-2.663v-4.247h2.663a2.161 2.161 0 0 1 2.193 2.123c0 .958-.797 2.124-2.193 2.124zm11.556-1.78c-1.35 0-2.755.59-3.333 1.896l1.66.687c.356-.687 1.013-.91 1.707-.91.97 0 1.954.576 1.969 1.593v.13c-.339-.193-1.063-.48-1.954-.48-1.787 0-3.607.973-3.607 2.787 0 1.66 1.463 2.728 3.109 2.728 1.258 0 1.952-.56 2.388-1.213h.064v.957h1.805v-4.75c0-2.196-1.659-3.425-3.808-3.425zm-.225 6.787c-.612 0-1.464-.3-1.464-1.05 0-.958 1.063-1.326 1.983-1.326.823 0 1.209.18 1.709.416a2.262 2.262 0 0 1-2.228 1.96zm10.611-6.516l-2.148 5.369h-.064l-2.222-5.369h-2.016l3.338 7.503-1.905 4.174h1.954l5.143-11.677h-2.08zm-16.851 7.924h1.874V17.652h-1.874v12.384z",
    fill: "#fff"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M16.348 33.969c-.235-.246-.371-.629-.371-1.125V15.152c0-.496.136-.879.371-1.125l.058-.054 9.914 9.91v.234l-9.914 9.91-.058-.058z",
    fill: "url(#i)",
    transform: "matrix(1.25299 0 0 -1.23841 -9.796 49.85)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M29.621 20.578l-3.301 3.305v.234l3.305 3.305.074-.043 3.914-2.227c1.117-.632 1.117-1.672 0-2.308l-3.914-2.223-.078-.043z",
    fill: "url(#j)",
    transform: "matrix(1.25299 0 0 -1.23841 -9.796 49.85)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M29.699 20.621L26.32 24l-9.972-9.973c.371-.39.976-.437 1.664-.047l11.687 6.641",
    fill: "url(#k)",
    transform: "matrix(1.25299 0 0 -1.23841 -9.796 49.85)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M29.699 27.379L18.012 34.02c-.688.386-1.293.339-1.664-.051L26.32 24l3.379 3.379z",
    fill: "url(#l)",
    transform: "matrix(1.25299 0 0 -1.23841 -9.796 49.85)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#m)",
    transform: "matrix(1.25299 0 0 -1.23841 -9.796 49.85)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#n)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h124v48H0V0z",
    fill: "url(#o)"
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#p)",
    transform: "matrix(1.25299 0 0 -1.23841 -9.796 49.85)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#q)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h124v48H0V0z",
    fill: "url(#r)"
  })))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#s)",
    transform: "matrix(1.25299 0 0 -1.23841 -9.796 49.85)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#t)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h124v48H0V0z",
    fill: "url(#u)"
  })))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#v)",
    transform: "matrix(1.25299 0 0 -1.23841 -9.796 49.85)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#w)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h124v48H0V0z",
    fill: "url(#x)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlayStore);
export default __webpack_public_path__ + "static/media/play_store.b29f5310b6d1e176eb82b3910f43dcc1.svg";
export { ForwardRef as ReactComponent };